import { render, staticRenderFns } from "./ListAltOutlined.vue?vue&type=template&id=703ae65a&"
import script from "./ListAltOutlined.vue?vue&type=script&lang=js&"
export * from "./ListAltOutlined.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports